import apiClient from '../utils/apiClient';

export const reportsApi = {
  getMissingTimesheetsLastWeek: async () => {
    const response = await apiClient.get('/reports/missing-timesheets/last-week');
    return response.data;
  },

  getMissingTimesheetsThisWeek: async () => {
    const response = await apiClient.get('/reports/missing-timesheets/this-week');
    return response.data;
  }
};
